import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useState } from "react";
import { Modal, TextInput } from "risa-oasis-ui_v2";
import { narRpaTrigger } from "../../../api/postCall/narRpaTrigger";
import { updatePrimaryDiagnosisCode } from "../../../api/postCall/updatePrimaryDiagnosisCode";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { ModalId } from "../../../enums/modalId";
import { logError } from "../../../utils/customLogger";
import { getOrgIdForFetchExternalWorklist } from "../../../utils/organizationHelper";
import { ToastMessages } from "../../toasts/toastMessages";

interface NarRpaTriggerModalProps {
  onClose: () => void;
  metaData: { orderId: string };
}
const NarRpaTriggerModal = (props: NarRpaTriggerModalProps) => {
  const [dxCode, setDxCode] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { submissionData, fetchAll } = useDataAccumulatorForSingleOrder();

  const triggerRPA = async () => {
    if (!dxCode.trim()) {
      toast.error(ToastMessages.DX_CODE_ERROR);
      return;
    }

    try {
      setIsLoading(true);
      await updatePrimaryDiagnosisCode(
        props.metaData.orderId,
        submissionData?.submission?.primary_diagnosis_details ?? [],
        dxCode.trim(),
      );
      await Promise.race([
        narRpaTrigger({
          order_id: props.metaData.orderId ?? "",
          org_id: getOrgIdForFetchExternalWorklist(),
        }),
        new Promise((resolve) =>
          setTimeout(() => resolve({ success: true }), 2000),
        ),
      ]);
      const orgId = getOrgIdForFetchExternalWorklist() ?? "";
      if (props.metaData.orderId && orgId) {
        await fetchAll(props.metaData.orderId, orgId);
      }
      toast.success(ToastMessages.NAR_RPA_TRIGGER_SUCCESS);
      props.onClose();
    } catch (error) {
      logError(error as Error);
      if (
        error instanceof Error &&
        error.message.includes("primary diagnosis")
      ) {
        toast.error(ToastMessages.PRIMARY_DIAGNOSIS_CODE_UPDATED_ERROR);
      } else {
        toast.error(ToastMessages.NAR_RPA_TRIGGER_ERROR);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      dialogId={ModalId.NAR_RPA_TRIGGER_MODAL}
      title="Valid Dx Code"
      onSave={triggerRPA}
      onClose={props.onClose}
      saveButtonText={isLoading ? "Updating..." : "Trigger RPA"}
      cancelText="Cancel"
      disableSave={isLoading || !dxCode.trim()}
    >
      <div className="pb-4">
        <TextInput
          id="nar-rpa-trigger-modal-input"
          label="Enter the Dx Code"
          defaultValue={dxCode}
          onChange={(data) => {
            setDxCode(data.value);
          }}
          readOnly={isLoading}
        />
      </div>
    </Modal>
  );
};

export default NarRpaTriggerModal;
